const HanaCloud = (
    <div className='md:w-4/5 mx-auto py-10 text-lg'>
        <h1 className='text-2xl font-bold'>
            S/4HANA Cloud
        </h1>
        <br />
        <div className='md:px-5 text-gray-500'>
            <p>SAP S/4 HANA Cloud offers some of the SAP ERP system modules and functionality of on-
                premises S/4HANA but with quarterly updates rather than annual updates. It is the SaaS version
                of S/4 HANA. Users access the software via a web browser on any device, and all business
                applications are launched from the SAP Fiori launchpad. It can be deployed on a public cloud or
                in a dedicated private cloud environment.
            </p>
            <br />
            <p>S/4 HANA Cloud includes in-memory computing for real-time data, as well as embedded
                analytics, machine learning support, the SAP S/4HANA Cloud Software Development Toolkit
                (SDK) to develop custom extensions for SAP S/4HANA, and two-tier deployment support for
                enterprises running one or more instances of SAP ERP products, such as headquarters and
                subsidiaries. SAP products like SuccessFactors, Fieldglass, Hybris, Concur and Ariba can be

                connected to S/4 HANA Cloud via SAP Cloud Platform. Additionally, SAP also offers SAP API
                Business Hub so that developers can build sample apps, extensions and integrations using SAP
                and partner APIs.
            </p>
            <br />
            <p className='font-bold text-gray-900'>As of late 2018, 1808 is the next SAP S/4 HANA Cloud release, which comes with AI-powered
                &quot;intelligent scenarios.&quot; These include the following:</p>
            <br />
            <ul className='md:px-10 list-disc pl-5'>
                <li>
                    unusual business situation detection for SAP Financial Statement Insights.
                </li>
                <br />
                <li>
                    RFx process automation from open purchase requisitions.

                </li>
                <br />
                <li>
                    improved buffer proposal calculations for materials.

                </li>
                <br />
                <li>
                    improved insights on potential sales order delays and planned delivering.
                </li>
                <br />
                <li>
                    natural language support for tracking sales orders, accounts payable (AP) and
                    accounts receivable (AR).
                </li>
                <br />
                <li>
                    situation handling, bringing urgent information to specific groups for immediate
                    reactions.
                </li>
                <br />
            </ul>
            <p>
                Also new are additional enhancements for machine learning, natural language processing and
                predictive analytics. SAP claims release 1808 also contains new smart staffing analytics for HR
                management and improvements in chemical compliance and quality management key
                performance indicators (KPIs).
            </p>
            <br />
            <p>
                SAP S/4HANA Cloud may be best suited for medium to large enterprises with over $250 million
                in annual sales, companies that do business globally and companies that require specialized
                functionality for their industry verticals, like manufacturing and professional services. However,
                SAP also markets S/4HANA Cloud to small and midsize businesses.
            </p>
            <br />
            <p>
                SAP prices S/4HANA Cloud on a monthly subscription basis, starting at $220 per user per month.
            </p>
            <br />
            <p>
                During implementation, SAP provides full support.
            </p>
            <br />
            <p>
                S/4HANA Cloud is available for a 14-day free trial upon request.
            </p>
        </div>
    </div>
)

export default HanaCloud